import {Component, inject, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {SearchInputComponent} from "../../../../shared/ui/search-input/search-input.component";
import {DropdownMenuComponent} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {OutlineButtonComponent} from "../../../../shared/ui/outline-button/outline-button.component";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../../shared/ui/full-button/full-button.component";
import {FullLengthPaginationComponent} from "../../../../shared/ui/pagination/full-length-pagination/full-length-pagination.component";
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import {SectionedDropdownComponent} from "../../../../shared/ui/sectioned-dropdown/sectioned-dropdown.component";
import {ActivatedRoute, Router} from "@angular/router";
import {UserManagementService} from "../../../data-access/user-management.service";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import _ from "lodash";
import {DotSpinnerComponent} from "../../../../shared/ui/loaders/dot-spinner.component";
import {ExamService} from "../../../../exam/data-access/exam.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {instanceStatusBadge} from "../../../../shared/utils/instanceStatusBadge";

@Component({
  selector: 'view-user-instances',
  templateUrl: './viewUserInstances.component.html',
  imports: [CommonModule, FontAwesomeModule, SearchInputComponent, DropdownMenuComponent, OutlineButtonComponent, FormsModule, MatIconModule, FullButtonComponent, FullLengthPaginationComponent, BreadcrumbComponent, SectionedDropdownComponent, DotSpinnerComponent]
})
export class ViewUserInstancesComponent implements OnInit {
  userService = inject(UserManagementService)
  examService = inject(ExamService)
  route = inject(ActivatedRoute);
  router = inject(Router);
  _snackBar = inject(MatSnackBar)
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement',
  }, {
    text: 'All Users',
    route: 'dashboard/UserManagement/AllUsers'
  }]
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  instances: any[] = []
  search_text = ''
  user_id = -1
  isSearchLoading = false
  increaseTimeDialog = false
  increaseTimeExamUUID = ''
  changeDueDateDialog = false
  changeDueDateExamUUID = ''
  resetFullExamDialog = false
  resetFullExamUUID = ''
  partialResetExamDialog = false
  partialResetExamUUID = ''
  partialResetExamPartInfo: any[] = []
  confirmNewInstance = false
  newInstanceUsername = ''
  newInstanceExamID = -1
  examTitle = ''
  increaseTimeMinutes = ''
  currentDate = new Date()
  newDueDate = new Date()
  partialResetExamPartPosition = -1
  increaseTimePartPosition = -1
  newExamInstanceOverrideDueDate: Date | null = null
  newExamInstanceMode: string | null = null
  exam_part_instances: any[] = []
  examModeDropdownItems: any[] = [
    {
      label: 'Standard',
      value: 'STANDARD',
      parentSelectable: false,
    },
    {
      label: 'Practice',
      value: 'PRACTICE',
      parentSelectable: false,
    },
    {
      label: 'Preview',
      value: 'PREVIEW',
      parentSelectable: false,
    },
  ]
  username: string = ''
  display_name: string = ''

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if(params['user_id']) {
        this.user_id = Number(params['user_id']);
        this.handleServiceCall()

        this.userService.getSingleUserDetails(Number(params['user_id'])).subscribe((response) => {
          if(response.success) {
            this.username = response.result.username;
            this.display_name = response.result.display_name;
          }
        })
      }
    })
  }

  // TODO figure out what to do with this duplicate code

  cancelIncreaseTimeSave() {
    this.increaseTimeDialog = false
    this.increaseTimeExamUUID = ''
    this.increaseTimeMinutes = ''
    this.partialResetExamPartInfo = []
    this.increaseTimePartPosition = -1
    this.exam_part_instances = []
  }

  increaseTimeSave() {
    this.examService.extendExamInstance(this.increaseTimeExamUUID, Number(this.increaseTimeMinutes), this.increaseTimePartPosition).subscribe((response) => {
      if(response.success) {
        this._snackBar.open('Exam Successfully Extended', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
      this.cancelIncreaseTimeSave()
    })
  }

  cancelChangeDueDate() {
    this.changeDueDateDialog = false
    this.changeDueDateExamUUID = ''
  }

  changeDueDateSave() {
    let tempDate = new Date(this.newDueDate)
    // TODO need to format newDueDate to correct timestamp format for API call
    this.examService.newOverallDueDate(this.changeDueDateExamUUID, tempDate.toISOString().split('.')[0]+"Z").subscribe((response) => {
      if(response.success) {
        this._snackBar.open('Due date successfully updated', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 3000, panelClass: ['error-snackbar']})
      }
      this.cancelChangeDueDate()
    })
  }

  cancelResetFullExam() {
    this.resetFullExamUUID = ''
    this.resetFullExamDialog = false
  }

  confirmResetFullExam() {
    this.examService.examFullReset(this.resetFullExamUUID).subscribe((response) => {
      if(response.success) {
        this.examService.removeExamInstance(this.resetFullExamUUID).subscribe((response) => {
          if(response.success) {
            this.handleServiceCall()
            this._snackBar.open('Exam Successfully Reset!', 'Dismiss', {duration: 3000})
            this.cancelResetFullExam()
          } else {
            this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
          }
        })
      } else {
        // Don't know if it would be better to keep dialog open or close it
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  cancelPartialExamReset() {
    this.partialResetExamDialog = false
    this.partialResetExamUUID = ''
    this.partialResetExamPartInfo = []
    this.partialResetExamPartPosition = -1
  }

  confirmPartialExamReset() {
    if(this.partialResetExamPartPosition !== -1 && this.partialResetExamUUID !== '') {
      this.examService.resetExamPart(this.partialResetExamUUID, this.partialResetExamPartPosition).subscribe((response) => {
        if(response.success) {
          this.handleServiceCall()
          this._snackBar.open('Exam Part Successfully Reset!', 'Dismiss', {duration: 3000})
          this.cancelPartialExamReset()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
        }
      })
    }
  }

  cancelNewExamInstance() {
    this.newInstanceUsername = ''
    this.newInstanceExamID = -1
    this.confirmNewInstance = false
  }

  confirmNewExamInstance() {
    if(this.newInstanceExamID !== -1 && this.newInstanceUsername !== null && this.newInstanceUsername !== '') {
      this.examService.assignNewExamInstance(this.newInstanceExamID, this.newInstanceUsername, this.newExamInstanceMode, this.newExamInstanceOverrideDueDate).subscribe((response) => {
        if (response.success) {
          this.handleServiceCall()
          this._snackBar.open('New Exam Instance Successfully Assigned!', 'Dismiss', {duration: 3000})
          this.cancelNewExamInstance()
          this.confirmResetFullExam()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
        }
      })
    }
  }

  debounceSearch = _.debounce(() => {
    this.handleServiceCall();
  }, 500)

  reviewInstance(item: any) {
    this.router.navigate(['dashboard/exam/submissions/review'], {
      queryParams: {
        exam_uuid: item.exam_uuid,
        exam_id: item.exam.exam_id,
        exam_title: item.exam.exam_title,
        display_name: this.display_name,
        username: this.username
      }
    })
  }

  handleServiceCall() {
    if(this.user_id !== -1) {
      this.isSearchLoading = true;
      this.userService.searchUserExamInstances(this.user_id, this.search_text, this.currentPagination.page, this.currentPagination.limit).subscribe((response) => {
        this.isSearchLoading = false;
        if(!response.success) {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
          return
        }
        // cleared here rather than before the request so the current rows stay visible (faded) while loading
        this.instances = []
        for(let item of response.result.items) {
          this.instances.push({
            ...item,
            ...instanceStatusBadge(item.status),
            // destructive resets kept last, behind a divider, so they're harder to hit by accident
            menuItem: [{
              title: 'Review Instance',
              action: () => this.reviewInstance(item)
            }, {
              title: 'View Comments',
              route: 'dashboard/exam/instances/comments',
              queryParams: {queryParams: {exam_uuid: item.exam_uuid}}
            }, {
              title: 'Increase Exam Part Time',
              action: () => {
                this.increaseTimeDialog = true
                this.increaseTimeExamUUID = item.exam_uuid
                this.examService.reviewExamInstance(item.exam_uuid).subscribe((response) => {
                  if (response.success) {
                    this.partialResetExamPartInfo = []
                    this.exam_part_instances = item.exam_part_instances
                    for (let part of response.result.parts) {
                      this.partialResetExamPartInfo.push({
                        name: part.details.part_name,
                        part_position: part.part_position
                      })
                    }
                  } else {
                    this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
                  }
                })
              }
            }, {
              title: 'Change Due Date',
              action: () => {
                this.changeDueDateDialog = true
                this.changeDueDateExamUUID = item.exam_uuid
              }
            }, {
              title: 'Assign New Instance',
              action: () => {
                this.confirmNewInstance = true
                // TODO we know username from user_id
                this.newInstanceUsername = item.username
                this.newInstanceExamID = item.exam.exam_id
              }
            }, {
              title: 'Reset Exam Part',
              danger: true,
              divider: true,
              action: () => {
                this.partialResetExamDialog = true
                this.partialResetExamUUID = item.exam_uuid
                this.examService.reviewExamInstance(item.exam_uuid).subscribe((response) => {
                  if (response.success) {
                    this.partialResetExamPartInfo = []
                    for (let part of response.result.parts) {
                      this.partialResetExamPartInfo.push({
                        name: part.details.part_name,
                        part_position: part.part_position
                      })
                    }
                  } else {
                    this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
                  }
                })
                // TODO call exam review or get exam details to get the part positions
              }
            }, {
              title: 'Reset Entire Exam',
              danger: true,
              action: () => {
                this.resetFullExamDialog = true
                this.resetFullExamUUID = item.exam_uuid
              }
            }]
          })
        }
      })
    }
  }
}
